import { render, staticRenderFns } from "./SubCompanies.vue?vue&type=template&id=ce1dd9da&scoped=true"
import script from "./SubCompanies.vue?vue&type=script&lang=js"
export * from "./SubCompanies.vue?vue&type=script&lang=js"
import style0 from "./SubCompanies.vue?vue&type=style&index=0&id=ce1dd9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1dd9da",
  null
  
)

export default component.exports